import { AgenciaDto } from "./agencia-dto";
import { BancoDto } from "./banco-dto";
import { CondicaoDocumentoDto } from "./condicao-documento-dto";
import { ModalidadeArrecadacaoDto } from "./modalidade-arrecadacao-dto";
import { NaturezaDto } from "./natureza-dto";
import { ReceitaDto } from "./receita-dto";
import { TipoDocumentoDto } from "./tipo-documento-dto";
import { TipoNIRDOC } from "./tipo-ni-rdoc";

export interface ParametrosPesquisaPagamento {
  numeroPagamento: string;
  numeroDocumento: string;
  tipoDocumento: TipoDocumentoDto,
  condicaoDocumento: CondicaoDocumentoDto,
  numeroReferencia: string;
  periodoArrecadacao: PeriodoArrecadacao;
  niSemDv: NISemDV;
  banco: BancoDto;
  agencia: AgenciaDto;
  faixaArrecadacao: FaixaArrecadacao;
  naturezaDocumento: NaturezaDto;
  codigoReceita: string; // Para consulta de Pagamentos que obrigam DIRF
  receita: ReceitaDto; // Para consulta de Pagamentos parametrizada
  nivelPesquisa: NivelPesquisa;
  modalidadeArrecadacao: ModalidadeArrecadacaoDto;
  debitosNaoEfetivadosDaraOnline: boolean;
}

export interface PeriodoArrecadacao {
  dataInicial: Date;
  dataFinal: Date;
}

export interface NISemDV {
  ni: string;
  tipoNi: TipoNIRDOC;
  niInvalido: boolean;
}

export interface FaixaArrecadacao {
  valorInicial: number;
  valorFinal: number;
}

export interface NivelPesquisa {
  tipo: TipoNivelPesquisa;
//   valor: UnidadeAdministrativaDto | RegiaoDto | undefined;
  valor: number;
}

export enum TipoNivelPesquisa {
  DELEGACIA = 1,
  REGIAO = 2,
  BRASIL = 3
}
